import { useState } from "react";
import { Lock, X } from "@phosphor-icons/react";
import { STATUS_LABELS } from "@/lib/api";
import StageSelector from "./StageSelector";
import { useEscClose } from "@/lib/useEscClose";

export default function PinModal({ orderNumber, fromStatus, initialToStatus, onConfirm, onCancel }) {
  const [toStatus, setToStatus] = useState(initialToStatus);
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useEscClose(onCancel);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await onConfirm(code, password, toStatus);
    } catch (err) {
      setError(err?.response?.data?.detail || "Falha na autenticação");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-6" onClick={onCancel}>
      <div className="glass w-full max-w-md p-6 sm:p-8 max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="pin-modal">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Lock size={18} weight="bold" />
            <div className="overline">AUTENTICAÇÃO DO COLABORADOR</div>
          </div>
          <button onClick={onCancel} className="hover:text-red-500"><X size={20} /></button>
        </div>
        <h2 className="font-head text-2xl font-black mb-2">Confirmar movimentação</h2>
        <p className="text-sm text-zinc-600 mb-4">
          Pedido <span className="font-mono font-semibold">#{orderNumber}</span>: <br />
          <span className="font-semibold">{STATUS_LABELS[fromStatus]}</span> → <span className="font-semibold">{STATUS_LABELS[toStatus]}</span>
        </p>
        <form onSubmit={submit} className="space-y-4">
          <StageSelector fromStatus={fromStatus} value={toStatus} onChange={setToStatus} />
          <div>
            <label className="label">Código do colaborador</label>
            <input className="input font-mono" autoFocus required value={code} onChange={(e) => setCode(e.target.value)} data-testid="pin-name" inputMode="numeric" />
          </div>
          <div>
            <label className="label">Senha</label>
            <input type="password" className="input" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="pin-password" />
          </div>
          {error && <div className="border border-[#E60000] bg-red-50 text-[#E60000] px-3 py-2 text-sm" data-testid="pin-error">{error}</div>}
          <div className="flex gap-3 pt-2">
            <button type="button" className="btn btn-ghost flex-1" onClick={onCancel}>Cancelar</button>
            <button type="submit" disabled={loading} className="btn flex-1" data-testid="pin-submit">{loading ? "Validando..." : "Confirmar"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
